import { createContext } from "react";
import { IState } from "machine/types/types";
import { MachineStore } from "MachineStore";
export type IMachineProvider = {
  AppState: IState;
  CheckoutState: IState;
  ResultState: IState;
};

type Iprops = {
  children?: any;
};
export const GlobalStateContext = createContext({});

function Provider(props: Iprops) {
  const store = MachineStore();
  const { children } = props;
  // const url = process.env.WEBSOCKET_URL || socketUrl["localhost"];
  // const [socket, val, socketSend] = useWs({
  //   url,
  //   collection: ["ProductMaster", "message", "OrderDetail", "Orders"],
  // });

  return (
    <GlobalStateContext.Provider value={{ socket: null, ...store }}>
      {children}
    </GlobalStateContext.Provider>
  );
}

export default Provider;
